var map = {
	"./AbsenceCallInteractionDTO.json": 97486,
	"./AbsenceCallLandingDTO.json": 24784,
	"./AbsenceCallReasonAndDurationDTO.json": 70180,
	"./AbsenceDTO.json": 96655,
	"./AbsenceDetailsChartsDTO.json": 28601,
	"./AbsenceDetailsDefaultReportFiltersDTO.json": 57062,
	"./AbsenceDetailsReportFiltersDTO.json": 39767,
	"./AbsenceDetailsReportResultDTO.json": 3255,
	"./AbsenceDetailsResultExportDTO.json": 16685,
	"./AbsenceDocumentDTO.json": 87401,
	"./AbsenceDynamicQuestionAnswerDTO.json": 5085,
	"./AbsenceEventNotificationDTO.json": 92388,
	"./AbsenceHistoryDTO.json": 7417,
	"./AbsenceManagementClientServiceDTO.json": 80578,
	"./AbsenceManagementDTO.json": 31004,
	"./AbsenceManagementSelfServiceDTO.json": 33070,
	"./AbsenceManagementSettingsDTO.json": 48040,
	"./AbsenceManagerNoteDTO.json": 93441,
	"./AbsenceMonitoringAdditionalSupportActionDTO.json": 72175,
	"./AbsenceMonitoringCurrentLevelDTO.json": 97242,
	"./AbsenceMonitoringDeferActionReasonDTO.json": 37435,
	"./AbsenceMonitoringDetailsChartsDTO.json": 52541,
	"./AbsenceMonitoringDetailsDefaultReportFiltersDTO.json": 53277,
	"./AbsenceMonitoringDetailsReportExportDTO.json": 11227,
	"./AbsenceMonitoringDetailsReportFiltersDTO.json": 84132,
	"./AbsenceMonitoringDetailsReportResultDTO.json": 89862,
	"./AbsenceMonitoringLevelDTO.json": 71038,
	"./AbsenceMonitoringLevelMovementDTO.json": 55910,
	"./AbsenceMonitoringNoActionReasonDTO.json": 76476,
	"./AbsenceMonitoringProcessDTO.json": 84356,
	"./AbsenceMonitoringProcessRevisionDTO.json": 1030,
	"./AbsenceMonitoringProcessTaskDTO.json": 84916,
	"./AbsenceMonitoringReviewTaskDTO.json": 27604,
	"./AbsenceMonitoringServiceSectionDTO.json": 18582,
	"./AbsenceMonitoringTaskDTO.json": 92048,
	"./AbsenceNoteDTO.json": 85423,
	"./AbsenceNoteSearchFilters.json": 70230,
	"./AbsenceNoteTypeDTO.json": 38899,
	"./AbsenceRatePercentageDTO.json": 81351,
	"./AbsenceRateTrendsDefaultReportFiltersDTO.json": 16218,
	"./AbsenceRateTrendsReportDTO.json": 61092,
	"./AbsenceRateTrendsReportFiltersDTO.json": 2255,
	"./AbsenceRateTrendsReportResultDTO.json": 26595,
	"./AbsenceReasonAbsenceProfileDTO.json": 39321,
	"./AbsenceReasonAlertTypeDTO.json": 49678,
	"./AbsenceReasonDaysLostDTO.json": 41357,
	"./AbsenceReasonGroupDTO.json": 75475,
	"./AbsenceReasonParentDTO.json": 1074,
	"./AbsenceReasonSearchFilters.json": 6842,
	"./AbsenceReasonTrendsChartsDTO.json": 5152,
	"./AbsenceReasonTrendsDefaultReportFiltersDTO.json": 72406,
	"./AbsenceReasonTrendsReportFiltersDTO.json": 74689,
	"./AbsenceReasonTrendsReportResultDTO.json": 46903,
	"./AbsenceReasonTypeDTO.json": 70432,
	"./AbsenceRecordingConfigurationDTO.json": 46861,
	"./AbsenceReferenceDTO.json": 8847,
	"./AbsenceRelatedTaskDTO.json": 51208,
	"./AbsenceRelatedTaskListDTO.json": 58900,
	"./AbsenceSmsDTO.json": 78971,
	"./AbsenceStandardQuestionAnswerDTO.json": 69628,
	"./AbsenceStatisticsDTO.json": 85850,
	"./AbsenceTimeLostDTO.json": 86491,
	"./AbsenceTotalsReportDTO.json": 84726,
	"./AbsenceTotalsReportFiltersDTO.json": 71555,
	"./AbsenceTrendsReportFiltersDTO.json": 15647,
	"./AccountManagerDTO.json": 57068,
	"./ActiveClientDTO.json": 39878,
	"./AdditionalQuestionCauseDTO.json": 20847,
	"./AddressDTO.json": 45054,
	"./AdminAccountDTO.json": 66362,
	"./AdvisorActivityDTO.json": 8439,
	"./AdvisorActivityExportDTO.json": 51040,
	"./AdvisorPerformanceDTO.json": 89058,
	"./AdvisorPerformanceExportDTO.json": 90673,
	"./AlertConfigurationAttachmentDTO.json": 80708,
	"./AlertConfigurationDTO.json": 42472,
	"./AlertConfigurationDetailsDTO.json": 11953,
	"./AlertConfigurationEmailContentDTO.json": 38928,
	"./AlertConfigurationEmployeeExclusionReasonDTO.json": 75283,
	"./AlertConfigurationRevisionDTO.json": 69255,
	"./AlertConfigurationSearchFilters.json": 68770,
	"./AlertConfigurationServiceLengthDTO.json": 9883,
	"./AlertConfigurationServiceSectionDTO.json": 42221,
	"./AlertConfigurationSummaryDTO.json": 81566,
	"./AlertConfigurationSummaryWithExclusionReasonsDTO.json": 70020,
	"./AlertDetailsChartsDTO.json": 72264,
	"./AlertDetailsDefaultReportFiltersDTO.json": 28464,
	"./AlertDetailsReportFiltersDTO.json": 77144,
	"./AlertDetailsResultDTO.json": 47511,
	"./AllergyDTO.json": 14729,
	"./AllergyDetailsDTO.json": 13820,
	"./ApprovalSummaryDTO.json": 53837,
	"./AssignmentExclusionDTO.json": 45331,
	"./AssignmentRuleDTO.json": 25265,
	"./AssignmentRuleExclusionDTO.json": 19207,
	"./AssignmentTargetDTO.json": 68920,
	"./AuditorDTO.json": 61753,
	"./AuthorisationRequiredAuthorisationKpiDTO.json": 43884,
	"./BlockChangeSetNotesDTO.json": 30329,
	"./BradfordScoreOverXInYMonthsDTO.json": 39646,
	"./BulkRegistrationEmailDTO.json": 61682,
	"./CallInteractionAdvisorNotesDTO.json": 36259,
	"./CallInteractionDTO.json": 44342,
	"./CallInteractionEventDTO.json": 97990,
	"./CallInteractionManagersNoteDTO.json": 30517,
	"./CallInteractionSearchFilters.json": 69737,
	"./CallScriptDTO.json": 20040,
	"./CallScriptSearchFilters.json": 81502,
	"./CallbackDTO.json": 57746,
	"./CallbackKpiDTO.json": 66322,
	"./CallbackQueueDTO.json": 20496,
	"./CallbackScheduledWindowDTO.json": 57888,
	"./CallbackScheduledWindowListDTO.json": 97364,
	"./CallbackSearchFilters.json": 41261,
	"./ChangeHomePageDTO.json": 69596,
	"./ChangePasswordDTO.json": 23690,
	"./ChangeSetDTO.json": 57413,
	"./ChangeSetExportDTO.json": 47501,
	"./ChangeSetSearchFilters.json": 11331,
	"./ChangeSetStateDTO.json": 76364,
	"./ClientAbsenceReasonDTO.json": 42322,
	"./ClientAbsenceReasonRateCalcExclusionDTO.json": 68722,
	"./ClientAbsenceReasonRevisionDTO.json": 67079,
	"./ClientAbsenceReasonServiceSectionDTO.json": 54369,
	"./ClientAbsenceReasonSummaryDTO.json": 86249,
	"./ClientCallbackSummaryDTO.json": 27162,
	"./ClientDTO.json": 16527,
	"./ClientExportDTO.json": 99116,
	"./ClientLogoDTO.json": 85504,
	"./ClientPlannedLeaveTaskDTO.json": 16206,
	"./ClientPlannedLeaveTaskSearchFilters.json": 65618,
	"./ClientPlannedLeaveTaskSummaryDTO.json": 83336,
	"./ClientSearchFilters.json": 16502,
	"./ClientServiceSummaryDTO.json": 10321,
	"./ClientSlaDTO.json": 46986,
	"./ClientUserDTO.json": 76505,
	"./ClientWithServiceConfigSummaryDTO.json": 15594,
	"./ComplianceTrendsDefaultReportFiltersDTO.json": 51771,
	"./ComplianceTrendsReportDTO.json": 74702,
	"./ComplianceTrendsReportFiltersDTO.json": 83322,
	"./ComplianceTrendsReportResultDTO.json": 97473,
	"./ComplianceTrendsReportRowDTO.json": 35335,
	"./ConditionDTO.json": 33334,
	"./ConfigChangeDTO.json": 56784,
	"./ContactDTO.json": 39341,
	"./ContactDetailsDTO.json": 91548,
	"./ContactInfoDTO.json": 96093,
	"./CountryDTO.json": 42945,
	"./CountryDataDTO.json": 39213,
	"./CreateNotificationDTO.json": 66452,
	"./CurrentStatusDTO.json": 69924,
	"./DashboardAbsenceNowDTO.json": 66701,
	"./DashboardOverviewDTO.json": 84808,
	"./DataFileChangeDTO.json": 17052,
	"./DataFileDTO.json": 88437,
	"./DataFileSearchFilters.json": 93833,
	"./DataFileUploadFormDTO.json": 47730,
	"./DataMigrationFileChangeDetailDTO.json": 25380,
	"./DataMigrationFileChangeGroupDTO.json": 77741,
	"./DataMigrationFileDTO.json": 89745,
	"./DataMigrationFileUploadFormDTO.json": 61410,
	"./DataRowDTO.json": 78538,
	"./DataSecurityEmailDomainsServiceSectionDTO.json": 56081,
	"./DataSecurityEmployeeIdentityServiceSectionDTO.json": 16438,
	"./DataSecurityGeneralSettingsServiceSectionDTO.json": 95703,
	"./DataSecurityMyfirstcareServiceSectionDTO.json": 39717,
	"./DefaultReportDTO.json": 15166,
	"./DeferChangeSetNotesDTO.json": 6782,
	"./DepartmentOverviewDTO.json": 39851,
	"./DepartmentOverviewExportDTO.json": 77429,
	"./DisableStaffGroupDTO.json": 39602,
	"./DraftApprovalDTO.json": 78600,
	"./DraftReviewDTO.json": 79951,
	"./DurationSecondsDTO.json": 30398,
	"./DynamicQuestionDTO.json": 41639,
	"./DynamicQuestionRevisionDTO.json": 68344,
	"./DynamicQuestionSearchFilters.json": 57745,
	"./DynamicQuestionServiceSectionDTO.json": 56520,
	"./DynamicQuestionSummaryDTO.json": 31578,
	"./EapServiceSectionDTO.json": 3864,
	"./EapSignpostingDTO.json": 11711,
	"./EapSignpostingReasonSpecificUsageDTO.json": 32275,
	"./EapSignpostingRevisionDTO.json": 454,
	"./EapSignpostingSearchFilters.json": 19824,
	"./EmailDomainRestrictionWhitelistDTO.json": 27534,
	"./EmailNotificationAttachmentDTO.json": 65249,
	"./EmailNotificationProcessDTO.json": 67565,
	"./EmailNotificationProcessReasonSpecificInstructionDTO.json": 29862,
	"./EmailNotificationProcessSearchFilters.json": 23555,
	"./EmailNotificationsServiceSectionDTO.json": 51682,
	"./EmployeeAbsenceAlertDTO.json": 99631,
	"./EmployeeAbsenceCountDTO.json": 90177,
	"./EmployeeAbsenceDTO.json": 9187,
	"./EmployeeAbsenceExportDTO.json": 80613,
	"./EmployeeAbsenceHistoryDTO.json": 57288,
	"./EmployeeAbsenceNotificationContentDTO.json": 53113,
	"./EmployeeAbsenceNotificationDTO.json": 18818,
	"./EmployeeAbsenceRecordingDTO.json": 43078,
	"./EmployeeAbsenceRtwInterviewFormDTO.json": 99944,
	"./EmployeeAbsenceSearchFilters.json": 16550,
	"./EmployeeAbsenceStatisticsDTO.json": 11849,
	"./EmployeeAbsenceStatisticsFiltersDTO.json": 57955,
	"./EmployeeAccessScopeDTO.json": 28668,
	"./EmployeeActivityHistoryDTO.json": 5895,
	"./EmployeeActivityHistorySearchFilters.json": 37135,
	"./EmployeeActivityHistorySummaryDTO.json": 62677,
	"./EmployeeAlertExclusionDTO.json": 28142,
	"./EmployeeAllergySearchFilters.json": 99365,
	"./EmployeeDTO.json": 70017,
	"./EmployeeFcIdDTO.json": 6822,
	"./EmployeeFileDTO.json": 12520,
	"./EmployeeFileSearchFilters.json": 75441,
	"./EmployeeFocusListChartsDTO.json": 75299,
	"./EmployeeFocusListDefaultReportFiltersDTO.json": 18620,
	"./EmployeeFocusListExportDTO.json": 91078,
	"./EmployeeFocusListReportFiltersDTO.json": 11371,
	"./EmployeeFocusListReportFiltersOptionalColumnsDTO.json": 12569,
	"./EmployeeFocusListResultDTO.json": 95676,
	"./EmployeeMedicalHistorySearchFilters.json": 77333,
	"./EmployeeMedicationSearchFilters.json": 49898,
	"./EmployeeNotificationSummaryDTO.json": 52583,
	"./EmployeePhoneSystemSearchResultDTO.json": 45918,
	"./EmployeePositionDTO.json": 68069,
	"./EmployeeSearchFilters.json": 76771,
	"./EmployeeSecurityQuestionDTO.json": 75451,
	"./EmployeeSmsNotificationsServiceSectionDTO.json": 49427,
	"./EmploymentInfoDTO.json": 51209,
	"./EmploymentSummaryDTO.json": 29958,
	"./ExceptionTypeDTO.json": 43108,
	"./ExcludedAlertDTO.json": 12495,
	"./ExportableUserDTO.json": 30475,
	"./FormQuestionAnswerDTO.json": 63032,
	"./FormQuestionAnswerValueDTO.json": 7564,
	"./FormQuestionDTO.json": 1423,
	"./HierarchyDTO.json": 70388,
	"./HierarchyDataFileSummaryDTO.json": 39612,
	"./HierarchyExceptionDTO.json": 94766,
	"./HierarchyExceptionGroupDTO.json": 44282,
	"./HierarchyMoveOperationDTO.json": 11417,
	"./HierarchyNodeDTO.json": 32117,
	"./HierarchyNotificationDTO.json": 43202,
	"./HierarchyNotificationSummaryDTO.json": 7377,
	"./HierarchyOperationDTO.json": 58579,
	"./HierarchyOperationSearchFilters.json": 82211,
	"./HierarchyRenameOperationDTO.json": 45491,
	"./HierarchyRevisionSummaryDTO.json": 9073,
	"./HierarchyScopeDTO.json": 15626,
	"./HierarchyShiftPatternDTO.json": 51414,
	"./HierarchyStructureExportRowDTO.json": 24148,
	"./HierarchyUnassignShiftPatternDTO.json": 81885,
	"./HistoricDataFileSummaryDTO.json": 87586,
	"./HistoricExceptionDTO.json": 32237,
	"./HistoricExceptionGroupDTO.json": 64270,
	"./HoursLostOverAvgWchInYPeriodOverZPeriodTypeDTO.json": 6420,
	"./IdListDTO.json": 22320,
	"./IndividualNotificationDTO.json": 57300,
	"./IndustryDTO.json": 18124,
	"./IpRestrictionWhitelistDTO.json": 30901,
	"./KeyAndLabelDTO.json": 73569,
	"./KpiComplianceDTO.json": 913,
	"./LifestyleChoicesDTO.json": 99432,
	"./ManagerComplianceReportDTO.json": 23099,
	"./ManagerComplianceReportFiltersDTO.json": 50951,
	"./ManagerFocusListChartsDTO.json": 28469,
	"./ManagerFocusListDefaultReportFiltersDTO.json": 1314,
	"./ManagerFocusListExportDTO.json": 4870,
	"./ManagerFocusListReportFiltersDTO.json": 44941,
	"./ManagerFocusListReportFiltersOptionalColumnsDTO.json": 97257,
	"./ManagerFocusListResultDTO.json": 94541,
	"./ManagerLoginsReportDTO.json": 5407,
	"./ManagerReferralQuestionDTO.json": 38565,
	"./ManagerReferralTaskDTO.json": 93695,
	"./ManagerReferralTaskQuestionAnswerDTO.json": 16506,
	"./ManagerSmsNotificationsServiceSectionDTO.json": 76717,
	"./ManualReferralDTO.json": 96405,
	"./ManualReferralProcessDTO.json": 45880,
	"./ManualReferralQuestionAnswerDTO.json": 458,
	"./ManualReferralQuestionDTO.json": 44068,
	"./MasterAlertTypeDTO.json": 33843,
	"./MasterDayTypeDTO.json": 7340,
	"./MasterEmploymentTypeDTO.json": 40209,
	"./MasterStaffGroupTypeDTO.json": 84178,
	"./MasterStandardQuestionDTO.json": 29837,
	"./MasterStandardQuestionTypeDTO.json": 51572,
	"./MasterStandardScriptDTO.json": 61825,
	"./MaterialisedPathDTO.json": 61153,
	"./MedicalDetailsDTO.json": 12751,
	"./MedicalHistoryDTO.json": 35801,
	"./MedicalTriageAdditionalSymptomDTO.json": 82262,
	"./MedicalTriageAdditionalSymptomListDTO.json": 93276,
	"./MedicalTriageAssessmentAdviceDTO.json": 96181,
	"./MedicalTriageAssessmentAdviceListDTO.json": 43931,
	"./MedicalTriageAssessmentAnswerDTO.json": 2232,
	"./MedicalTriageAssessmentAnswerListDTO.json": 62195,
	"./MedicalTriageAssessmentDTO.json": 47605,
	"./MedicalTriageAssessmentOutcomeDTO.json": 58501,
	"./MedicalTriageClassificationDTO.json": 28409,
	"./MedicalTriageConfigDTO.json": 50214,
	"./MedicalTriageDTO.json": 8894,
	"./MedicalTriageLifestyleAdviceDTO.json": 7217,
	"./MedicalTriageLifestyleAdviceListDTO.json": 16869,
	"./MedicalTriageScriptDTO.json": 83961,
	"./MedicalTriageScriptSearchFilters.json": 60620,
	"./MedicalTriageSymptomDTO.json": 31849,
	"./MedicationDTO.json": 21693,
	"./MedicationDetailsDTO.json": 80244,
	"./MessageDTO.json": 9134,
	"./MyAbsenceChartsDTO.json": 62851,
	"./MyAbsenceDTO.json": 39954,
	"./MyAbsenceDetailsDTO.json": 74550,
	"./MyAbsenceMonitoringHistoryDTO.json": 7641,
	"./MyAbsenceMonitoringStageDTO.json": 83468,
	"./MyAbsenceSearchFilters.json": 75489,
	"./MyDetailsDTO.json": 15902,
	"./MyEmployeeNotificationContactDTO.json": 80393,
	"./MyNotificationDTO.json": 93706,
	"./MyNotificationSearchFilters.json": 83192,
	"./MyfirstcareDataFileSummaryDTO.json": 62243,
	"./MyfirstcareExceptionDTO.json": 29431,
	"./MyfirstcareExceptionGroupDTO.json": 35995,
	"./NotificationAbsenceDTO.json": 68512,
	"./NotificationAbsenceHistoryDTO.json": 5527,
	"./NotificationAlertDTO.json": 35700,
	"./NotificationApprovalDTO.json": 97666,
	"./NotificationCallbackDTO.json": 98849,
	"./NotificationCallbackFailureDTO.json": 1643,
	"./NotificationContactSearchFilters.json": 30241,
	"./NotificationDTO.json": 44051,
	"./NotificationDynamicQuestionDTO.json": 33252,
	"./NotificationEmployeeDTO.json": 83831,
	"./NotificationPasswordResetDTO.json": 16599,
	"./NotificationQuestionAnswerDTO.json": 80987,
	"./NotificationRestrictedContentDTO.json": 1401,
	"./NotificationReturnToWorkDTO.json": 62181,
	"./NotificationStandardRegistrationDTO.json": 91669,
	"./NumberAndPercentageDTO.json": 61655,
	"./NurseDeclineReasonDTO.json": 29531,
	"./NurseDeclineReasonRevisionDTO.json": 77473,
	"./NurseDeclineReasonSearchFilters.json": 12107,
	"./NurseDeclineReasonServiceSectionDTO.json": 94002,
	"./NurseDeclineReasonSummaryDTO.json": 56935,
	"./NurseTransferAcceptQueueDTO.json": 11977,
	"./NurseTransferCallbackDTO.json": 98881,
	"./NurseTransferOfferDTO.json": 12125,
	"./OneOfDTO.json": 57252,
	"./OperatingCompanyAdvisorDTO.json": 98768,
	"./OperatingCompanyNurseDTO.json": 4094,
	"./OperatingCompanyUserDTO.json": 41524,
	"./OrganisationalUnitAbsenceProfileDTO.json": 90281,
	"./OrganisationalUnitFocusListChartsDTO.json": 29971,
	"./OrganisationalUnitFocusListDefaultReportFiltersDTO.json": 11002,
	"./OrganisationalUnitFocusListExportDTO.json": 77880,
	"./OrganisationalUnitFocusListReportFiltersDTO.json": 187,
	"./OrganisationalUnitFocusListReportFiltersOptionalColumnsDTO.json": 95156,
	"./OrganisationalUnitFocusListResultDTO.json": 4879,
	"./OutstandingTasksOverviewExportDTO.json": 31683,
	"./PagerRestrictionDTO.json": 91583,
	"./PagerRestrictionSearchFilters.json": 55993,
	"./PatchDTO.json": 45049,
	"./PercentageDTO.json": 24483,
	"./PersonalContactInfoDTO.json": 81740,
	"./PersonalDetailsDTO.json": 38277,
	"./PlannedLeaveDTO.json": 20562,
	"./PlannedLeaveFileDTO.json": 98397,
	"./PlannedLeaveSearchFilters.json": 31987,
	"./PlannedLeaveServiceSectionDTO.json": 68720,
	"./PlannedLeaveTaskDTO.json": 79207,
	"./PlannedLeaveTimeLostDTO.json": 75561,
	"./PlannedLeaveTimeLostDayDTO.json": 613,
	"./PlatformClientServiceDTO.json": 13534,
	"./PlatformDTO.json": 47231,
	"./PlatformSelfServiceDTO.json": 9451,
	"./PlatformSettingsDTO.json": 47915,
	"./ProfileDTO.json": 75100,
	"./PureCloudSearchResultDTO.json": 46523,
	"./QueryCallDTO.json": 69564,
	"./QueryCallInteractionDTO.json": 91493,
	"./QueryTypeDTO.json": 2371,
	"./ReasonOverviewDTO.json": 60316,
	"./ReasonOverviewExportDTO.json": 76577,
	"./ReferralDetailsChartsDTO.json": 31592,
	"./ReferralDetailsDefaultReportFiltersDTO.json": 31123,
	"./ReferralDetailsReportFiltersDTO.json": 22021,
	"./ReferralDetailsResultDTO.json": 32098,
	"./ReferralDetailsResultExportDTO.json": 4494,
	"./ReferralEmployeeReferralsDTO.json": 35470,
	"./ReferralEmployeeReferralsDeclinedReasonDTO.json": 27072,
	"./ReferralManagerReferralsDTO.json": 32423,
	"./ReferralManagerReferralsDeclinedReasonDTO.json": 69306,
	"./ReferralManagerReferralsFormFileDTO.json": 43776,
	"./ReferralManualReferralsDTO.json": 81642,
	"./ReferralManualReferralsReasonDTO.json": 34735,
	"./ReferralProcessDTO.json": 62977,
	"./ReferralProcessRevisionDTO.json": 72285,
	"./ReferralProcessRevisionDTO_ORIGINAL_BACKUP.json": 134,
	"./ReferralProcessSearchFilters.json": 86242,
	"./ReferralProcessSummaryDTO.json": 94773,
	"./ReferralSupplierTrackingDTO.json": 61759,
	"./ReferralSupplierTrackingDeclinedReasonDTO.json": 33320,
	"./ReferralSupplierTrackingOutcomeDTO.json": 62319,
	"./RegionDTO.json": 79781,
	"./RemoteAddressInfoDTO.json": 9482,
	"./ReportingParametersServiceSectionDTO.json": 93691,
	"./ResellerDTO.json": 14800,
	"./ResetPasswordDTO.json": 59193,
	"./ResetPasswordRequestDTO.json": 49351,
	"./ResponseEntity.json": 46766,
	"./RevisionDTO.json": 94733,
	"./RtwAttachmentAbsenceReasonsDTO.json": 32848,
	"./RtwAttachmentFileDTO.json": 75142,
	"./RtwDetailsChartsDTO.json": 99204,
	"./RtwDetailsDefaultReportFiltersDTO.json": 5316,
	"./RtwDetailsReportFiltersDTO.json": 52688,
	"./RtwDetailsResultDTO.json": 84016,
	"./RtwDetailsResultExportDTO.json": 61894,
	"./RtwInterviewProcessDTO.json": 31374,
	"./RtwInterviewProcessRevisionDTO.json": 20449,
	"./RtwInterviewProcessSearchFilters.json": 4705,
	"./RtwInterviewQuestionDTO.json": 34398,
	"./RtwInterviewTaskDTO.json": 74045,
	"./RtwInterviewTaskQuestionAnswerDTO.json": 97041,
	"./RtwInterviewsServiceSectionDTO.json": 10596,
	"./RtwLateSubmissionReasonDTO.json": 30672,
	"./SIPDataFileDTO.json": 10232,
	"./SIPDataMigrationFileDTO.json": 32891,
	"./SalaryDTO.json": 74057,
	"./SavedReportDTO.json": 96295,
	"./SearchCriteriaDTO.json": 49359,
	"./SearchDTO.json": 14813,
	"./ServiceConfigSummaryDTO.json": 84776,
	"./ServiceConfigurationDTO.json": 63755,
	"./ServiceConfigurationSummaryDTO.json": 47880,
	"./ServiceConfigurationTemplateDTO.json": 68288,
	"./ServiceDTO.json": 49024,
	"./ServiceSectionDTO.json": 54507,
	"./ServiceSectionStatusDTO.json": 9166,
	"./ServiceSettingsServiceSectionDTO.json": 8263,
	"./ShiftPatternDTO.json": 36352,
	"./ShiftPatternDayDTO.json": 24732,
	"./ShiftPatternSearchFilters.json": 82006,
	"./ShortAbsenceMonitoringLevelDTO.json": 81572,
	"./ShortActiveClientDTO.json": 38809,
	"./ShortAlertDTO.json": 79853,
	"./ShortClientDTO.json": 74656,
	"./ShortDynamicQuestionDTO.json": 10845,
	"./ShortEmployeeDTO.json": 37993,
	"./ShortEmployeePositionDTO.json": 9478,
	"./ShortFormQuestionDTO.json": 61090,
	"./ShortOrganisationalUnitDTO.json": 93989,
	"./ShortShiftPatternDTO.json": 48079,
	"./ShortSipExceptionDTO.json": 52546,
	"./ShortSpecialContacTypeDTO.json": 47327,
	"./ShortStaffGroupDTO.json": 55146,
	"./SickPayAuthorisationDTO.json": 40194,
	"./SickPayAuthorisationDeclinedReasonDTO.json": 13343,
	"./SickPayAuthorisationRevisionDTO.json": 7583,
	"./SickPayAuthorisationSearchFilters.json": 25431,
	"./SickPayAuthorisationServiceSectionDTO.json": 9110,
	"./SipExceptionDTO.json": 48690,
	"./SipExceptionTypeDTO.json": 16192,
	"./SlaDTO.json": 42453,
	"./SlaPerformanceDefaultReportFiltersDTO.json": 63262,
	"./SlaPerformanceReportDTO.json": 49465,
	"./SlaPerformanceReportEntryDTO.json": 60391,
	"./SlaPerformanceReportFiltersDTO.json": 39430,
	"./SmsRestrictionDTO.json": 20703,
	"./SmsRestrictionSearchFilters.json": 50803,
	"./SmsWellbeingPromptDTO.json": 6924,
	"./SmsWellbeingPromptSearchFilters.json": 71947,
	"./SpecialContactDTO.json": 78749,
	"./SpecialContactEmployeeDTO.json": 80036,
	"./SpecialContactSearchFilters.json": 8326,
	"./SpecialContactTypeDTO.json": 527,
	"./StaffGroupDTO.json": 14461,
	"./StaffGroupSearchFilters.json": 87031,
	"./StaffGroupsServiceSectionDTO.json": 22280,
	"./StandardCallScriptDTO.json": 70671,
	"./StandardQuestionDTO.json": 37506,
	"./StandardQuestionRevisionDTO.json": 8240,
	"./StandardQuestionSearchFilters.json": 54101,
	"./StandardQuestionServiceSectionDTO.json": 20885,
	"./StandardScriptDTO.json": 49084,
	"./StandardScriptRevisionDTO.json": 9707,
	"./StandardScriptSearchFilters.json": 67844,
	"./StandardScriptServiceSectionDTO.json": 33125,
	"./StatisticDTO.json": 53016,
	"./SubmitChangeSetNotesDTO.json": 7138,
	"./SupplierReferralTaskDTO.json": 44752,
	"./SupplierReferralTaskListDTO.json": 23897,
	"./SupplierReferralTaskSearchFilters.json": 38787,
	"./SymptomAdviceDTO.json": 2815,
	"./SymptomDTO.json": 42097,
	"./SymptomQuestionDTO.json": 72779,
	"./TaskDTO.json": 10820,
	"./TaskSearchFilters.json": 72805,
	"./TemporaryEmployeeDTO.json": 30894,
	"./TreatmentDTO.json": 97355,
	"./TrendActivityDTO.json": 33779,
	"./TrendActivityExportDTO.json": 15895,
	"./TrendSpotlightAbsenceReportDTO.json": 37620,
	"./TrendSpotlightDefaultReportFiltersDTO.json": 57366,
	"./TrendSpotlightReportDTO.json": 84281,
	"./TrendSpotlightReportFiltersDTO.json": 88428,
	"./UnassignFromShiftPatternDTO.json": 17742,
	"./UserLoginDTO.json": 3874,
	"./UserLoginSearchFilters.json": 10543,
	"./UserPermissionsServiceSectionDTO.json": 33310,
	"./UserSearchFilters.json": 28208,
	"./UserStatusUpdateDTO.json": 11693,
	"./ValueDTO.json": 26577,
	"./WellbeingReferralsServiceSectionDTO.json": 4281,
	"./WorkRelatedDTO.json": 94473,
	"./XDayTypeInYPeriodTypeDTO.json": 33937,
	"./XDayTypeOfContinuousAbsenceDTO.json": 24714,
	"./XDayTypeOrZSpellsInYPeriodTypeDTO.json": 58423,
	"./XDayTypeOverZSpellsInYPeriodTypeDTO.json": 6243,
	"./XHoursInYPeriodTypeDTO.json": 99049,
	"./XSpellsInYPeriodTypeDTO.json": 96930,
	"./XSpellsOfSameReasonInYPeriodTypeDTO.json": 91843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78630;